import { useEffect, useState } from 'react'
import { postWithAuth } from '../common'
import { formatDate, formatTime } from '../lib/format'
import SectionCard from './ui/SectionCard'
import Button from './ui/Button'
import { Table, TableHead, TableRow, TableHeaderCell, TableCell, TableEmpty } from './ui/Table'

export default function ClientActivityLog({ orgId, clientId, clientNumber }) {
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [version, setVersion] = useState(0)
    useEffect(() => {
        let active = true
        setData(null); setError(''); setLoading(true)
        postWithAuth('fetchClientActivity', { orgId, clientId }, { force: true }).then(response => {
            if (response?.err || !Array.isArray(response?.data?.entries)) throw new Error('Client activity is not available. The tracking service may need deployment.')
            if (active) setData(response.data)
        }).catch(() => { if (active) setError('Client activity is unavailable. Please retry after the tracking service is deployed.') })
            .finally(() => { if (active) setLoading(false) })
        return () => { active = false }
    }, [orgId, clientId, version])
    const loadMore = async () => {
        setLoading(true); setError('')
        try {
            const response = await postWithAuth('fetchClientActivity', { orgId, clientId, cursor: data.cursor })
            if (response?.err || !response?.data) throw new Error()
            setData(current => ({ ...response.data, entries: [...current.entries, ...response.data.entries] }))
        } catch (_) { setError('Unable to load more activity. Please retry.') }
        finally { setLoading(false) }
    }
    return <SectionCard title='Client Activity Log' subtitle={`Client ID: ${data?.clientNumber || clientNumber || 'Awaiting assignment'}`} actions={<Button disabled={loading} onClick={() => setVersion(value => value + 1)}>Refresh</Button>}>
        {error && <p role='alert'>{error}</p>}
        {loading && <p role='status'>Loading activity…</p>}
        {data && <Table><TableHead><TableRow><TableHeaderCell>Date / Time</TableHeaderCell><TableHeaderCell>Activity</TableHeaderCell><TableHeaderCell>Changes</TableHeaderCell><TableHeaderCell>By</TableHeaderCell></TableRow></TableHead><tbody>
            {data.entries.map(entry => <TableRow key={entry.id}>
                <TableCell>{formatDate(new Date(entry.date), 'd MMM yyyy')}<br />{formatTime(new Date(entry.date))}</TableCell>
                <TableCell>{entry.action}{entry.details && <div className='uiTableSecondary'>{entry.details}</div>}</TableCell>
                <TableCell>{entry.changes?.length ? entry.changes.map(change => <div key={change.field}><strong>{change.field.replace(/([a-z])([A-Z])/g, '$1 $2')}: </strong>{change.before} → {change.after}</div>) : '—'}</TableCell>
                <TableCell>{entry.actorName}</TableCell>
            </TableRow>)}
            {!data.entries.length && <TableEmpty colSpan={4}>No activity recorded yet.</TableEmpty>}
        </tbody></Table>}
        {data?.cursor && <Button disabled={loading} onClick={loadMore}>Load more</Button>}
        <p className='sectionHelperText'>Creation dates come from stored records. Updates and site changes are recorded from tracking activation onward.</p>
    </SectionCard>
}
